<template>
	<div class="fullBoxs" ref="fullBoxs">
		<userHeader />
		<div class="fullBox">
			<div class="fullTit">
				<div class="fullTxt">
					<img src="@/assets/img/jx.svg" alt="" />
					<span v-if="tlFlag">{{ tmDecs.name }}</span>
					<span v-if="!tlFlag">{{ tmDecs1.name }}</span>
					<span v-if="!tlFlag">（{{ tmDecs1.testCenter }}）</span>
				</div>

				<div class="fullRig" v-if="$route.path == '/yulanSt'" @click="onFullScreen">
					<img src="@/assets/img/编组 (1).png" alt="" />
					<span>退出</span>
				</div>
				<template v-else>
					<div class="fullRig" v-if="tlFlag" @click="onFullScreen">
						<img src="@/assets/img/编组 (1).png" alt="" />
						<span>退出</span>
					</div>
					<div class="fullRig" v-else @click="tlFns">
						<!-- <img src="@/assets/img/编组 (1).png" alt=""> -->
						<span>返回</span>
					</div>
				</template>
			</div>
			<div class="fullBbox" v-if="tlFlag">
				<div class="fullTi" v-for="(item, index) in tmDecs.yydTextbookQuestions" :key="index">
					<myAudio
						v-if="item.audioFlag"
						:audioUrl="item.questionAudioFilePath"
						:ref="'mys' + index"
						@fullhdFn="fullhdFn"
						:refName="'myAudio' + index"
						:title="item.questionAudioFileName"
						types="3"
					/>
					<div v-for="(i, s) in item.yydSmallQuestionList" :key="s">
						<div class="fullT">
							{{ i.title }}
						</div>
						<div class="fullDt">
							<p v-for="(a, b) in i.yydSmallQuestionOptionList" :key="b" @click="funs(i, item, a)" :class="{ fullDts: i.vals == a.number }">
								{{ a.number }} 、{{ a.content }}
							</p>
						</div>
					</div>
					<div class="dajbox" v-if="item.kgFlag">
						<div class="lookJx" @click="item.jxFlag = !item.jxFlag">
							查看解析
							<i class="el-icon-caret-bottom" v-if="!item.jxFlag"></i>
							<i class="el-icon-caret-top" v-if="item.jxFlag"></i>
						</div>
						<div class="lookDaBox" v-show="item.jxFlag && item.kgFlag">
							<div class="lookDaTit">正确答案：{{ item.yydSmallQuestionList.map((item) => item.answer).join(' ') }}</div>
							<div class="lookDaCont">
								<p class="lookDaContP" v-html="$removeSty(item.originalContent)"></p>
							</div>
							<div class="lookDaBtn supHove3" @click="tltBtn(item)">同类题</div>
						</div>
					</div>
				</div>
			</div>
			<div class="fullBbox" v-if="!tlFlag">
				<div class="fullTi" v-for="(item, index) in tmDecs1.yydTextbookQuestions" :key="index">
					<myAudio
						v-if="item.audioFlag"
						:audioUrl="item.questionAudioFilePath"
						:ref="'myss' + index"
						@fullhdFn="fullhdFn1"
						:refName="'myAudios' + index"
						:title="item.questionAudioFileName"
						types="3"
					/>
					<div class="msBox">
						<div class="msTit"></div>
						<!-- <div class="shitiLzDel shitiLzDel1 supHove3" :class="{'shitiLzDelhs': item.isAddBasket}"  @click="addBtn(item)">
                <i class="el-icon-plus" v-if="!item.isAddBasket"></i>
                {{item.isAddBasket?'已':''}}加入试题篮
              </div> -->
					</div>
					<div v-for="(i, s) in item.yydSmallQuestionList" :key="s">
						<div class="fullT">
							{{ i.title }}
						</div>
						<div class="fullDt">
							<p v-for="(a, b) in i.yydSmallQuestionOptionList" :key="b" @click="funs(i, item, a)" :class="{ fullDts: i.vals == a.number }">
								{{ a.number }} 、{{ a.content }}
							</p>
						</div>
					</div>
					<div class="dajbox" v-if="item.kgFlag">
						<div class="lookJx" @click="item.jxFlag = !item.jxFlag">
							查看解析
							<i class="el-icon-caret-bottom" v-if="!item.jxFlag"></i>
							<i class="el-icon-caret-top" v-if="item.jxFlag"></i>
						</div>
						<div class="lookDaBox" v-show="item.jxFlag && item.kgFlag">
							<div class="lookDaTit">正确答案：{{ item.yydSmallQuestionList.map((item) => item.answer).join(' ') }}</div>
							<div class="lookDaCont">
								<p class="lookDaContP" v-html="$removeSty(item.originalContent)"></p>
							</div>
							<div class="shitiLzDel shitiLzDel1 supHove3 lookDaBtn lookDaBtn1" :class="{ shitiLzDelhs: item.isAddBasket }" @click="addBtn(item)">
								<i class="el-icon-plus" v-if="!item.isAddBasket"></i>
								{{ item.isAddBasket ? '已' : '' }}加入试题篮
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import myAudio from '@/components/pubComponents/myAudio';
import userHeader from '@/components/hearder/userHeader';
import axios from 'axios';

export default {
	name: 'fullScreen',
	data() {
		return {
			tmDecs: {}, // 试卷
			tmDecs1: {}, // 同类题
			xArr: 'A,B,C,D,E,F,G',
			daRefName: '',
			daName: '',
			fullScreen: '',
			observer: '',
			tlFlag: false
		};
	},
	props: ['tmDec', 'lzFlag'],
	components: {
		userHeader,
		myAudio
	},
	methods: {
		// 退出同类题
		tlFns() {
			this.tlFlag = true;
			//  this.tlFlag =  this.$route.path != '/yulanSt'?true:false
			// if(this.tmDec) {
			//   let datas = JSON.parse(this.tmDec)
			//   console.log(datas,222)
			//   let num = 1
			//   datas.yydTextbookQuestions.forEach((item) => {
			//     item.audioFlag = false
			//     item.questionAudioFilePath = ''
			//     item.questionAudioFileName = ''
			//     item.jxFlag = true
			//     item.kgFlag = false
			//     item.yydSmallQuestionList.forEach((i) => {
			//       i.num = num
			//       i.vals = ''
			//       num++
			//     })
			//   });
			//   this.tmDecs = datas
			//   this.initAll()
		},
		// 全屏
		onFullScreen() {
			if (this.fullscreen) {
				this.$fullscreen.exit(); //退出全屏
				this.fullscreen = '';
				this.$emit('gbFn');
			} else {
				// 通过ref拿到具体的、希望全屏展示的元素
				let dom = this.$refs['fullBoxs'];
				//打开全屏
				console.log(this.$fullscreen.enter, this.$fullscreen, dom, 8888888888888);
				this.$fullscreen.enter(dom, {
					wrap: false,
					callback: (f) => {
						this.fullscreen = f;
					}
				});
			}
		},
		fullhdFn(refs, refName) {
			if (this.daRefName) {
				if (this.daRefName != refs) {
					this.daRefName.pause();
					this.$refs['mys' + this.daName.match(/\d+/g)[0]][0].playFlag = false;
					this.daRefName = refs;
					this.daName = refName;
				}
			} else {
				this.daRefName = refs;
				this.daName = refName;
			}
		},
		fullhdFn1(refs, refName) {
			if (this.daRefName) {
				if (this.daRefName != refs) {
					this.daRefName.pause();
					this.$refs['myss' + this.daName.match(/\d+/g)[0]][0].playFlag = false;
					this.daRefName = refs;
					this.daName = refName;
				}
			} else {
				this.daRefName = refs;
				this.daName = refName;
			}
		},
		breaFn() {
			// this.$router.back()
		},
		async initAll() {
			// 给数组循环赋值
			let newArr = '';
			if (this.tlFlag) {
				newArr = this.tmDecs.yydTextbookQuestions.map(async (item) => {
					item.questionAudioFilePath = await this.getAudio(item); // 年龄赋值等待
					return item;
				});
			} else {
				newArr = this.tmDecs1.yydTextbookQuestions.map(async (item) => {
					item.questionAudioFilePath = await this.getAudio(item); // 年龄赋值等待
					return item;
				});
			}
			// Promise接收一个数组
			await Promise.all(newArr);
			// 执行完毕，再往下走
			console.log('最终加工好的数组结果：', newArr, this.tmDecs1);
		},
		tltBtn(item) {
			this.$http
				.get('api/app/yydExaminationQuestion/list', {
					params: {
						sort: 1,
						sortComprehensive: Math.floor(Math.random() * 1000000)
							.toString()
							.padStart(6, '0'),
						testCenter: item.testCenterName,
						pageNum: 1,
						pageNum: 30
					}
				})
				.then((res) => {
					if (res.code == 200) {
						if (res.rows) {
							let num = 1;
							res.rows.forEach((item) => {
								item.audioFlag = false;
								item.questionAudioFilePath = '';
								item.questionAudioFileName = '';
								item.jxFlag = true;
								item.kgFlag = false;
								item.yydSmallQuestionList.forEach((i) => {
									i.num = num;
									i.vals = '';
									num++;
								});
							});
							this.tlFlag = false;
							this.$set(this.tmDecs1, 'yydTextbookQuestions', res.rows);
							this.$set(this.tmDecs1, 'name', '同类题');
							this.$set(this.tmDecs1, 'testCenter', item.testCenterName);
							this.initAll();
							console.log(this.tmDecs1, 88777999);
						}
					}
				});
		},
		addBtn(it) {
			console.log(it, 222);
			if (it.isAddBasket) {
				return;
			}
			let set = this.$loading(this.$pre);
			this.$http.post(`api/app/yydQuestionBasket/add/${it.examinationQuestionId}`).then((res) => {
				set.close();
				if (res.code == 200) {
					this.$message({
						type: 'success',
						message: '添加成功'
					});
					this.$set(it, 'isAddBasket', 1);
				}
			});
		},
		getAudio(item) {
			return new Promise((resolve, reject) => {
				this.$http
					.get('api/app/common/getUrl', {
						params: {
							fileId: item.recordingFileId,
							clientType: 1
						}
					})
					.then((res) => {
						if (res.code == 200) {
							item.questionAudioFileName = res.fileName;
							axios({
								method: 'get',
								url: res.msg,
								// timeout: 600000, // 请求超时时间，数据量多后台响应慢的情况可以调大点，没生效的话可能是vue.config.js里的配置影响了
								responseType: 'blob', // 返回类型为数据流
								headers: {
									clientType: 1,
									token: `${localStorage.getItem('token')}`
								}
							}).then((red) => {
								if (red && red.data) {
									const blob = new Blob([red.data], { type: 'audio/mpeg' });
									item.questionAudioFilePath = URL.createObjectURL(blob);
									item.audioFlag = true;
									resolve(item.questionAudioFilePath);
								}
							});
						}
					});
			});
		},
		funs(i, item, a) {
			i.vals = a.number;
			if (item.yydSmallQuestionList.filter((r) => r.vals).length == item.yydSmallQuestionList.length) {
				item.kgFlag = true;
			}
		},
		setupFullscreenListener() {
			document.addEventListener('fullscreenchange', this.onFullscreenChange);
		},
		removeFullscreenListener() {
			document.removeEventListener('fullscreenchange', this.onFullscreenChange);
		},
		onFullscreenChange() {
			if (!document.fullscreenElement) {
				console.log('已退出全屏');
				this.onFullScreen();
				// 执行你的退出全屏后的逻辑
			}
		}
	},
	mounted() {
		console.log(122222222222);
		this.setupFullscreenListener();
		this.tlFlag = this.$route.path != '/yulanSt' ? true : false;
		if (this.tmDec) {
			let datas = JSON.parse(this.tmDec);
			console.log(datas, 222);
			let num = 1;
			datas.yydTextbookQuestions.forEach((item) => {
				item.audioFlag = false;
				item.questionAudioFilePath = '';
				item.questionAudioFileName = '';
				item.jxFlag = true;
				item.kgFlag = false;
				item.yydSmallQuestionList.forEach((i) => {
					i.num = num;
					i.vals = '';
					num++;
				});
			});
			if (this.tlFlag) {
				this.tmDecs = datas;
			} else {
				this.tmDecs1 = datas;
			}
			this.initAll();
		}
	},
	beforeDestroy() {
		// 移除事件监听器
		this.removeFullscreenListener();
	}
};
</script>
<style lang="scss" scoped>
.fullBoxs {
	height: 100vh;
	width: 100vw;
	box-sizing: border-box;
	background: #253246;
	.fullBox {
		padding: 0 50px;
		.fullTit {
			display: flex;
			justify-content: space-between;
			height: 93px;
			padding-bottom: 10px;
			align-items: center;
			color: #fff;
			.fullRig {
				display: flex;
				align-items: center;
				font-size: 18px;
				cursor: pointer;
				img {
					width: 18px;
					height: 18px;
					margin-right: 10px;
				}
			}
			.fullTxt {
				font-size: 28px;
				font-weight: bold;
				display: flex;
				align-items: center;
				cursor: pointer;
				img {
					width: 42px;
					height: 41px;
					margin-right: 16px;
				}
			}
		}
	}
}
.fullBbox {
	height: calc(100vh - 163px);
	overflow: hidden;
	overflow-y: auto;
	/* 隐藏垂直滚动条 */
	&::-webkit-scrollbar {
		width: 0;
	}

	/* 隐藏水平滚动条 */
	&::-webkit-scrollbar {
		height: 0;
	}
	.fullTi {
		margin-bottom: 52px;
		color: #fff;
		font-size: 24px;
		.fullT {
			margin: 18px 0 23px;
			cursor: pointer;
			display: flex;
			justify-content: space-between;
			&:hover {
				color: #f7ff00;
			}
		}

		.fullDt {
			p {
				height: 50px;
				background: #303d50;
				border-radius: 8px;
				padding-left: 31px;
				line-height: 50px;
				margin-bottom: 10px;
				box-sizing: border-box;
				border: 1px solid transparent;

				cursor: pointer;
				&:last-of-type {
					margin-bottom: 0px;
				}
			}
			p:hover {
				color: #f7ff00;
				border: 1px solid #f7ff00;
			}
		}
		.fullDts {
			color: #f7ff00;
			border: 1px solid #f7ff00;
		}
	}
}
.dajbox {
	padding: 15px 30px 20px;
	margin: 15px 0;
	position: relative;
	border: 2px solid #1d7b3a;
	border-radius: 8px;
}
.lookJx {
	color: #1d7b3a;
	cursor: pointer;
	margin-bottom: 20px;
}
.lookDaBox {
	.lookDaTit {
		font-weight: bold;
		font-size: 18px;
		color: #d33931;
		margin-bottom: 16px;
	}
	.lookDaCont {
		margin-bottom: 20px;
		span {
			color: #1d7b3a;
		}
		.lookDaContP {
			width: auto;
			height: auto;
			border-radius: 0;
			color: #fff !important;
			box-sizing: border-box;
		}
	}
	.lookDaBtn {
		width: 88px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		font-size: 16px;
		background: #1d7b3a;
		color: #fff;
		cursor: pointer;
		border-radius: 6px;
		position: absolute;
		top: 15px;
		right: 30px;
	}
	.lookDaBtn1 {
		width: 120px !important;
	}
}

.msBox {
	display: flex;
	justify-content: space-between;
	margin-bottom: -15px;
	.msTit {
		font-size: 16px;
	}
}
.shitiLzDel {
	width: 78px;
	height: 30px;
	background: #ffffff;
	box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
	border: 1px solid #d8e0f0;
	font-size: 12px;
	color: #000000;
	border-radius: 4px;
	box-sizing: border-box;
	text-align: center;
	line-height: 30px;
	cursor: pointer;
}
.shitiLzDel1 {
	width: 92px;
	height: 30px;
	background: #1d7b3a;
	border: 1px solid #14652d;
	font-size: 12px;
	color: #ffffff;
	line-height: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	i {
		margin-right: 2px;
	}
}
.shitiLzDelhs {
	opacity: 0.6;
	cursor: no-drop;
}
</style>
